import {DeliveriesState} from './deliveries.state';
import {createReducer, on} from '@ngrx/store';
import {DeliveriesActions} from './deliveries.index';

export const deliveriesFeatureKey = 'deliveries';

const initialState: DeliveriesState = {
  plannedDeliveries: [],
  deliveriesAreLoading: false,
  chartModel: {
    isLoading: false,
    options: undefined
  },
  deliveryStatusIcons: new Map<string, string>(),
  validatedPbos: undefined
};

const reducer = createReducer(
  initialState,
  on(DeliveriesActions.LOAD_PLANNED_DELIVERIES, state => ({...state, deliveriesAreLoading: true})),
  on(DeliveriesActions.LOAD_PLANNED_DELIVERIES_ERROR, state => state),
  on(
    DeliveriesActions.LOAD_PLANNED_DELIVERIES_SUCCESS,
    (state, action) => ({
      ...state,
      plannedDeliveries: action.deliveries,
      deliveriesAreLoading: false
    })
  ),
  on(DeliveriesActions.UPDATE_PLANNED_DELIVERY, state => ({...state, deliveriesAreLoading: false, chartModel: undefined})),
  on(DeliveriesActions.UPDATE_PLANNED_DELIVERY_SUCCESS, state => state),
  on(DeliveriesActions.UPDATE_PLANNED_DELIVERY_ERROR, state => state),
  on(DeliveriesActions.LOAD_DELIVERIES_CHART, state => ({...state, chartModel: {options: undefined, isLoading: true}})),
  on(DeliveriesActions.LOAD_DELIVERIES_CHART_SUCCESS,
    (state, action) => ({
      ...state,
      chartModel: {
        isLoading: false,
        options: action.chartOptions
      }
    })
  ),
  on(DeliveriesActions.LOAD_DELIVERIES_CHART_ERROR, state => ({...state, chartModel: {isLoading: false, options: undefined}})),
  on(DeliveriesActions.LOAD_DELIVERY_ICONS, state => state),
  on(DeliveriesActions.LOAD_DELIVERY_ICONS_SUCCESS,
    (state, action) => ({
      ...state,
      deliveryStatusIcons: action.icons
    })
  ),
  on(DeliveriesActions.CREATE_PLANNED_DELIVERY, state => state),
  on(DeliveriesActions.CREATE_PLANNED_DELIVERY_SUCCESS, state => state),
  on(DeliveriesActions.CREATE_PLANNED_DELIVERY_ERROR, state => state),
  on(DeliveriesActions.CREATE_DELIVERYNOTE, state => state),
  on(DeliveriesActions.CREATE_DELIVERYNOTE_SUCCESS, state => state),
  on(DeliveriesActions.CREATE_DELIVERYNOTE_ERROR, state => state),
  on(DeliveriesActions.VALIDATE_PBO_SUBTYPES, state => state),
  on(DeliveriesActions.VALIDATE_PBO_SUBTYPES_SUCCESS,
    (state, action) => ({
      ...state,
      validatedPbos: action.pbos
    })
  ),
  on(DeliveriesActions.VALIDATE_PBO_SUBTYPES_ERROR, state => state)
);

export function deliveriesReducer(state: DeliveriesState, action) {
  return reducer(state, action);
}
